// Ajustes del telefono de este puesto. Se guardan en este navegador (igual que el softphone anterior).
// Pendiente de seguridad (fase 1 del mapa 3CX): entregar las credenciales SIP desde el servidor tras el login.

import { KEYS, readJSON, writeJSON } from '../lib/storage';

export type ModoTelefono = 'web' | '3cx' | 'demo';

export type PhoneConfig = {
  modo: ModoTelefono;
  ws: string;
  usuario: string;
  clave: string;
  extension: string;
  nombre: string;
  sonarTimbre: boolean;
  // Volumen del timbre, 0 a 1 (D68).
  volumenTimbre: number;
  // Llamadas internas (extension a extension): tipificar solo si la persona quiere, o siempre (D69).
  tipificarInternas: 'opcional' | 'siempre';
  abrirFicha: 'sonar' | 'contestar' | 'nunca';
  autoConectar: boolean;
  // Dispositivos elegidos en la prueba de audio ('' = el predeterminado del sistema).
  microfono: string;
  altavoz: string;
  // Cuando paso la prueba de audio completa por ultima vez (0 = nunca).
  ensayoHecho: number;
};

export const defaultWs = () => {
  if (typeof location === 'undefined') return 'ws://localhost:8088/ws';
  const segura = location.protocol === 'https:';
  return segura ? `wss://${location.hostname}/voz/ws` : `ws://${location.hostname || 'localhost'}:8088/ws`;
};

export const DEFAULT_CONFIG: PhoneConfig = {
  modo: 'web',
  ws: '',
  usuario: '',
  clave: '',
  extension: '',
  nombre: '',
  sonarTimbre: true,
  volumenTimbre: 0.6,
  tipificarInternas: 'opcional',
  abrirFicha: 'sonar',
  autoConectar: true,
  microfono: '',
  altavoz: '',
  ensayoHecho: 0,
};

export function loadConfig(): PhoneConfig {
  const c = readJSON<PhoneConfig>(KEYS.telefono, DEFAULT_CONFIG);
  return { ...DEFAULT_CONFIG, ...c, ws: c.ws || defaultWs() };
}

export const saveConfig = (c: PhoneConfig) => writeJSON(KEYS.telefono, c);

export const configurado = (c: PhoneConfig) =>
  c.modo === 'demo' || (c.modo === '3cx' ? !!c.extension : !!(c.ws && c.usuario && c.clave));
